import { Directive, Input, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RouterLinkBackService } from './router-link-back.service';

@Directive({
  selector: '[routerLinkBack]',
  standalone: false,
  hostDirectives: [{ directive: RouterLink }]
})
export class RouterLinkBackDirective implements OnInit {
  @Input('routerLinkBack') fallbackRoute: string | string[] = '/';

  private routerLink = inject(RouterLink);
  private service = inject(RouterLinkBackService);

  ngOnInit() {
    this.routerLink.routerLink = this.service.previousRoute || this.fallbackRoute;
  }
}
